export type AppKey =
  | 'evac'
  | 'alert'
  | 'livecount'
  | 'safehuman'
  | 'compliassist'

export const PEOPLE_APPS = [
  'evac',
  'alert',
  'livecount',
  'safehuman',
] as const satisfies readonly AppKey[]

export const PROPERTY_APPS = [
  'compliassist',
] as const satisfies readonly AppKey[]

// Logos live in /public/apps, mockups in /public/apps/mocks, icons in
// /public/apps/icons. `icon` is the light variant for dark cards,
// `colorIcon` the brand-blue one for white surfaces (header menu).
// `desktop` marks laptop/computer mockups (vs. phone), which are
// right-aligned in the card instead of centered.
export const APP_ASSETS: Record<
  AppKey,
  { logo: string; mock: string; icon: string; colorIcon: string; desktop?: boolean }
> = {
  evac: {
    logo: '/apps/minimal/evacapp-logo.webp',
    mock: '/apps/mocks/mock-evacapp.webp',
    icon: '/apps/icons/evacapp-secondary-icon.webp',
    colorIcon: '/apps/icons/evacapp-icon.webp',
  },
  alert: {
    logo: '/apps/minimal/alertapp-logo.webp',
    mock: '/apps/mocks/mock-alertapp.webp',
    icon: '/apps/icons/alertapp-secondary-icon.webp',
    colorIcon: '/apps/icons/alertapp-icon.webp',
  },
  livecount: {
    logo: '/apps/minimal/livecount-logo.webp',
    mock: '/apps/mocks/mock-livecount.webp',
    icon: '/apps/icons/livecount-secondary-icon.webp',
    colorIcon: '/apps/icons/livecount-icon.webp',
  },
  safehuman: {
    logo: '/apps/minimal/safehuman-logo.webp',
    mock: '/apps/mocks/mock-safehuman.webp',
    icon: '/apps/icons/safehuman-secondary-icon.webp',
    colorIcon: '/apps/icons/safehuman-icon.webp',
    desktop: true,
  },
  compliassist: {
    logo: '/apps/minimal/compliassist-logo.webp',
    mock: '/apps/mocks/mock-compliassist.webp',
    icon: '/apps/icons/compliassist-secondary-icon.webp',
    colorIcon: '/apps/icons/compliassist-icon.webp',
    desktop: true,
  },
}
